import {omneticApi} from '@dms/api/base';

import {
  CreateRecordAuditDefinitionApiResponse,
  CreateRecordAuditDefinitionApiArg,
  ListRecordAuditDefinitionApiResponse,
  ListRecordAuditDefinitionApiArg,
  DeleteRecordAuditDefinitionApiResponse,
  DeleteRecordAuditDefinitionApiArg,
  GetRecordAuditDefinitionApiResponse,
  GetRecordAuditDefinitionApiArg,
  UpdateRecordAuditDefinitionApiResponse,
  UpdateRecordAuditDefinitionApiArg,
} from './types';

const injectedRtkApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    createRecordAuditDefinition: build.mutation<
      CreateRecordAuditDefinitionApiResponse,
      CreateRecordAuditDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/record-audit/definition`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: [{type: 'RecordAuditDefinition'}],
    }),
    listRecordAuditDefinition: build.query<
      ListRecordAuditDefinitionApiResponse,
      ListRecordAuditDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/record-audit/definition`,
        params: queryArg.resourceId ? {resourceId: queryArg.resourceId} : undefined,
      }),
    }),
    deleteRecordAuditDefinition: build.mutation<
      DeleteRecordAuditDefinitionApiResponse,
      DeleteRecordAuditDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/record-audit/definition/${queryArg.definitionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{type: 'RecordAuditDefinition'}],
    }),
    getRecordAuditDefinition: build.query<
      GetRecordAuditDefinitionApiResponse,
      GetRecordAuditDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/record-audit/definition/${queryArg.definitionId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'RecordAuditDefinition', id: queryArg.definitionId},
      ],
    }),
    updateRecordAuditDefinition: build.mutation<
      UpdateRecordAuditDefinitionApiResponse,
      UpdateRecordAuditDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/record-audit/definition/${queryArg.definitionId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'RecordAuditDefinition', id: queryArg.definitionId},
        {type: 'RecordAuditDefinition'},
      ],
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as recordAuditDefinitionApi};

export const {
  useCreateRecordAuditDefinitionMutation,
  useListRecordAuditDefinitionQuery,
  useDeleteRecordAuditDefinitionMutation,
  useGetRecordAuditDefinitionQuery,
  useUpdateRecordAuditDefinitionMutation,
} = injectedRtkApi;
